import { render } from "./Questions.vue?vue&type=template&id=4cc10920"
import script from "./Questions.vue?vue&type=script&lang=js"
export * from "./Questions.vue?vue&type=script&lang=js"

import "./Questions.vue?vue&type=style&index=0&id=4cc10920&lang=scss"

import exportComponent from "/Users/jeromebart/sites/cdm-quiz/cite-des-metiers/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__